module.exports = __webpack_public_path__ + "static/media/31.1b2b0166.mp3";